module.exports = __webpack_public_path__ + "img/new-arrow.3cd6162c.svg";